/* Every home widget. Add one: write an IWidgetDefinition (useWidget → IWidgetResult) and list it here;
   it gets a nav entry, 1–9 key, collapse, snooze, filter, move and the widget picker for free. */
import type { IWidgetDefinition } from "../homeDashboard.types"
import { docsWidget } from "./docsWidget"
import { adSpendWidget } from "./adSpendWidget"
import { aixTodosWidget } from "./aixTodosWidget"
import { dataCoverageWidget } from "./dataCoverageWidget"
import { engDeliveryWidget } from "./engDeliveryWidget"
import { gatewaySpendWidget } from "./gatewaySpendWidget"
import { uptimeMonitorsWidget } from "./monitorsWidget"
import { myWorkWidget } from "./myWorkWidget"
import { deploysWidget, incidentsWidget } from "./opsWidgets"
import { productPulseWidget } from "./productPulseWidget"
import { revenueWidget } from "./revenueWidget"
import { missionWidget } from "./missionWidget"
import { betsWidget } from "./vidmaxPlanWidgets"

export const WIDGETS: IWidgetDefinition[] = [
  missionWidget,
  myWorkWidget,
  incidentsWidget,
  uptimeMonitorsWidget,
  deploysWidget,
  revenueWidget,
  adSpendWidget,
  productPulseWidget,
  gatewaySpendWidget,
  engDeliveryWidget,
  dataCoverageWidget,
  aixTodosWidget,
  betsWidget,
  docsWidget,
]
